import React from 'react';
import { createStore } from 'little-state-machine';
import { withRouter } from 'react-router-dom';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';
import Step5 from './step5';
import Final from './final';
import './onboardingStyles.css';
import { compose } from 'redux';
import { connect } from 'react-redux';

createStore({
	data: {},
});

const OnBoard = ({ location: { pathname }, newUser }) => {
	return (
		<div className="container nopadding-mobile">
			<div className="container-fluid onb">
				<div id="page-wrapper">
					<div id="page-inner">
						<h2 className="ob-heading">
							{newUser ? 'Welcome!' : 'Welcome back to STEP!'}
						</h2>
						<div className="ob-title">
							To help personalise your STEP experience, please tell us a little bit
							about yourself!
						</div>
						<p className="ob-desc"> This will only take 2 minutes!</p>
						<div className="stepwizard">
							<div
								style={{ pointerEvents: 'none' }}
								className="stepwizard-row setup-panel"
							>
								<div className="stepwizard-step ">
									<button
										aria-label="1"
										type="button"
										className={`btn ${
											pathname === '/onboard/step1' ? 'btn-success' : 'btn-default'
										} btn-circle`}
									>
										1
									</button>
									<p>
										<small>Background</small>
									</p>
								</div>
								<div className="stepwizard-step ">
									<button
										aria-label="2"
										type="button"
										className={`btn ${
											pathname === '/onboard/step2' ? 'btn-success' : 'btn-default'
										} btn-circle`}
									>
										2
									</button>
									<p>
										<small>Parent?</small>
									</p>
								</div>
								<div className="stepwizard-step ">
									<button
										aria-label="3"
										type="button"
										className={`btn ${
											pathname === '/onboard/step3' ? 'btn-success' : 'btn-default'
										} btn-circle`}
									>
										3
									</button>
									<p>
										<small>WhatsApp</small>
									</p>
								</div>
								<div className="stepwizard-step ">
									<button
										aria-label="4"
										type="button"
										className={`btn ${
											pathname === '/onboard/step4' ? 'btn-success' : 'btn-default'
										} btn-circle`}
									>
										4
									</button>
									<p>
										<small>Subscribe</small>
									</p>
								</div>
								<div className="stepwizard-step ">
									<button
										aria-label="5"
										type="button"
										className={`btn ${
											pathname === '/onboard/step5' ? 'btn-success' : 'btn-default'
										} btn-circle`}
									>
										5
									</button>
									<p>
										<small>Name</small>
									</p>
								</div>
								<div className="stepwizard-step ">
									<button
										aria-label="6"
										type="button"
										className={`btn ${
											pathname === '/onboard/final' ? 'btn-success' : 'btn-default'
										} btn-circle`}
									>
										6
									</button>
									<p>
										<small>Done</small>
									</p>
								</div>
							</div>
							{pathname === '/onboard/step1' && <Step1 />}
							{pathname === '/onboard/step2' && <Step2 />}
							{pathname === '/onboard/step3' && <Step3 />}
							{pathname === '/onboard/step4' && <Step4 />}
							{pathname === '/onboard/step5' && <Step5 />}
							{pathname === '/onboard/final' && <Final />}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { newUser } = state.rootReducer.loginDetails;
	return {
		newUser,
	};
};

export default compose(withRouter, connect(mapStateToProps))(OnBoard);
